import { Badge, Text } from '@mantine/core';
import React from 'react';

import { useConfig } from '@portals/api/partners';

export function PartnerToPartnerStatus() {
  const config = useConfig();

  if (config.data?.visible_to_other_partners) return null;

  return (
    <Badge radius="xl" size="sm" color="indigo.0">
      <Text color="blue_gray.9" weight={400}>
        Deactivated
      </Text>
    </Badge>
  );
}
